import React, { useState, useEffect, useRef } from 'react';
import { Fecha } from '../../../componentes/Fecha'
import { esMayor, fechasEstaIncluida } from '../../../Helpers/fechas'
import { useContextoGlobal } from '../../../Context/contextoGlobal';
import { Button, Option, Select, Typography } from '@material-tailwind/react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';

export const Cabecera = ({ setCrearIglesia,
    toggle,
    filtrarLista,
    limpiarFiltros,
    filtrosActivos,
    usuario,
    regiones,
    cuentas,
    handleDataChanges,
    dataValues,
    handleChangeSelectRegion,
}) => {

    const [textoSucursal, setTextoSucursal] = useState("");
    const [textoConcepto, setTextoConcepto] = useState("");
    const { esCelular } = useContextoGlobal();
    const estados = [{ 
        id_region: 'Libre', nombre: 'Libre' 
    }, 
    { 
        id_region: 'Asignado', nombre: 'Asignado' 
    },
    { 
        id_region: 'Fraccionado', nombre: 'Fraccionado' 
    },
    { 
        id_region: 'Anonimo', nombre: 'Anónimo' 
    }]

    const handleChangeInputSucursal = (e) => {

        setTextoSucursal(e.target.value)

    }

    const handleChangeInputConcepto = (e) => {

        setTextoConcepto(e.target.value)

    }

    const limpiarSucursal = () => {

        setTextoSucursal("")

    }

    const handleStatusChange = (e) => {
        handleDataChanges(e, 'estado')
    }

    const handleCuentaChange = (e) => {
        handleDataChanges(e, 'id_cuenta_bancaria')
    }

    const handleSearchData = () => {
        const callback = (item) =>
            item.desc_sucursal?.toUpperCase().includes(textoSucursal.toUpperCase()) &&
            item.concepto?.toUpperCase().includes(textoConcepto.toUpperCase()) &&
            fechasEstaIncluida(dataValues.fecha_desde, dataValues.fecha_hasta, item.fecha);

        if (esMayor(dataValues.fecha_desde, dataValues.fecha_hasta)) {
            alert('El orden de las fechas es incorrecto');
        } else {
            filtrarLista(callback);
        }
    };


    return <div className='flex f-col mt-4'>
        <div className={`flex ${esCelular ? 'f-col space-y-2' : 'f-row space-x-4'} justify-center flex-wrap abc`}>
            {usuario.sede_admin && <SeleccionadorXLabel titulo='Región'
                vector={regiones}
                onchange={handleChangeSelectRegion}
                claves={{ id: 'id_region', nombre: 'nombre' }}
                valor={dataValues.id_region}
                nombre='Seleccione una región'
            />
            }
            <div>
                <Typography
                    variant="small"
                    className="mb-1 font-medium "
                >
                    Fecha Desde
                </Typography>
                <Fecha fecha={dataValues.fecha_desde} setFecha={(e) => handleDataChanges(e, 'fecha_desde')} />
            </div>
            <div>
                <Typography
                    variant="small"
                    className="mb-1 font-medium "
                >
                    Fecha Hasta
                </Typography>
                <Fecha fecha={dataValues.fecha_hasta} setFecha={(e) => handleDataChanges(e, 'fecha_hasta')} />
            </div>
            
            <SeleccionadorXLabel titulo='Cuenta Bancaria'
                vector={cuentas.map(item => ({ id_region: item.id_cuenta_bancaria, nombre: item.descripcion }))}
                onchange={handleCuentaChange}
                claves={{ id: 'id_region', nombre: 'nombre' }}
                valor={dataValues.id_cuenta_bancaria}
                nombre='Seleccione una cuenta'
            />

            <SeleccionadorXLabel titulo='Estado'
                vector={estados}
                onchange={handleStatusChange}
                claves={{ id: 'id_region', nombre: 'nombre' }}
                valor={dataValues.estado}
                nombre='Seleccione un estado'
            />
            {/*
                <Box sx={{}}>
                    <Typography
                        variant="small"
                        className="mb-1 font-medium "
                    >
                        Sucursal
                    </Typography>
                    <TextField fullWidth id="texto-sucursal" inputProps={{}} value={textoSucursal} onChange={handleChangeInputSucursal} variant="outlined" />
                </Box>
                <Box sx={{}}>
                    <Typography
                        variant="small"
                        className="mb-1 font-medium "
                    >
                        Concepto
                    </Typography>
                    <TextField fullWidth id="texto-concepto" inputProps={{}} value={textoConcepto} onChange={handleChangeInputConcepto} variant="outlined" />
                </Box>
            */}
          
        </div>
          <div class="flex justify-center lg:justify-end gap-2 ... lg:mr-4">
                {typeof limpiarFiltros === 'function' && filtrosActivos && (
                    <Button
                        size="lg"
                        variant="outlined"
                        color="blue-gray"
                        className="rounded flex items-center mt-[28px]"
                        onClick={limpiarFiltros}
                    >
                        <XMarkIcon className="h-4 w-4 mr-2" />Limpiar
                    </Button>
                )}
                <Button
                    size="lg"
                    color="blue"
                    className="rounded flex mt-[28px]"
                    onClick={handleSearchData}
                >
                    <MagnifyingGlassIcon className="h-4 w-4 mr-2" />Buscar
                </Button>
            </div>
    </div>
}

const SeleccionadorXLabel = ({ vector, onchange, valor, nombre, limpiar, claves, titulo, noDefault }) => {

    return <div className='select-ui-data !mb-4'>
        <Typography
            variant="small"
            className="mb-1 font-medium "
        >
            {titulo}
        </Typography>
        <Select
            label="Seleccione una opción"
            value={valor}
            onChange={onchange}
            className='h-14'
        >
            {vector.map((item, index) => (
                <Option key={index} value={item.id_region}>
                    {item.nombre}
                </Option>
            ))}
        </Select>
    </div>
}




